import React, { Fragment } from "react";

import { Box } from "@material-ui/core";

import { Post } from "@hubcapp/components";
import { getBrandDisplayName } from "@hubcapp/utils";

import { PostListProps } from "./types";
import PostListSkeleton from "./PostListSkeleton";

const POSTS_MAX_WIDTH = 1055;

const PostList: React.FC<PostListProps> = ({ loading, posts = [] }) =>
  loading ? (
    <Box marginTop={3} maxWidth={POSTS_MAX_WIDTH}>
      <PostListSkeleton />
    </Box>
  ) : (
    <Fragment>
      {posts.map(({ id, brand, content, date }) => (
        <Box key={id} id={id} marginBottom={4} maxWidth={POSTS_MAX_WIDTH}>
          <Post
            author={getBrandDisplayName(brand)}
            brand={brand}
            content={content}
            date={date}
            id={id}
          />
        </Box>
      ))}
    </Fragment>
  );

export default PostList;
